(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sirius-calculator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tab');
  let currentCalculator = 'onboard';

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      currentCalculator = tab.dataset.calculator;
      resetFunction(); // Reset the calculator when a tab is clicked
    });
  });

  document.getElementById('ceiling-calculate').addEventListener('click', calculate);

  function calculate() {
    var lengthEl = document.getElementById("ceiling-length");
    var widthEl = document.getElementById("ceiling-width");
    var heightEl = document.getElementById("ceiling-height");
    var length = parseFloat(lengthEl.value);
    var width = parseFloat(widthEl.value);
    var height = parseFloat(heightEl.value);
    var resultEl = document.getElementById("ceiling-result");
    var result8 = document.getElementById("ceiling-result8");
    var result10 = document.getElementById("ceiling-result10");
    var result12 = document.getElementById("ceiling-result12");

    if (length || width || height === "") {
      document.getElementById("result-container").classList.remove("hidden");
      document.getElementById("result-container").classList.add("block");     
    }

    // Clear any existing error messages
    lengthEl.nextElementSibling.innerHTML = "";
    widthEl.nextElementSibling.innerHTML = "";
    heightEl.nextElementSibling.innerHTML = "";
    
    // Check if any input fields are blank
    if (isNaN(length)) {
      lengthEl.nextElementSibling.innerHTML = "Please enter a value.";
    }
    if (isNaN(width)) {
      widthEl.nextElementSibling.innerHTML = "Please enter a value.";
    }
    if (isNaN(height)) {
      heightEl.nextElementSibling.innerHTML = "Please enter a value.";
    }
    
    // If any fields are blank, don't perform the calculation
    if (isNaN(length) || isNaN(width) || isNaN(height)) {
      resultEl.innerHTML = "";
      return;
    }
    
    var volume = length * width * height;
    resultEl.innerHTML = "Total volume: " + volume.toLocaleString() + "m<sup>3</sup>";

    let factor8, factor10, factor12, text8, text10, text12;
    if (currentCalculator === 'onboard') {
      factor8 = 8;
      factor10 = 10;
      factor12 = 12;
      text8 = "For basic single pot or pan cooking";
      text10 = "For heavy frying or multiple pots & pans";
      text12 = "For serious cooking, lots of smoke & steam";
    } else {
      factor8 = 6;
      factor10 = 8;
      factor12 = 10;
      text8 = "For general single pan cooking";
      text10 = "For heavy frying and multiple pan cooking";
      text12 = "For large open areas, and strong cooking odours and smoke";
    }

    var volume8x = volume * factor8;
    result8.innerHTML = `${text8}: ${volume8x.toLocaleString()}m<sup>3</sup>`;

    var volume10x = volume * factor10;
    result10.innerHTML = `${text10}: ${volume10x.toLocaleString()}m<sup>3</sup>`;

    var volume12x = volume * factor12;
    result12.innerHTML = `${text12}: ${volume12x.toLocaleString()}m<sup>3</sup>`;
  }

  resetFunction = () => { 
    document.getElementById("ceiling-length").nextElementSibling.innerHTML = "";
    document.getElementById("ceiling-width").nextElementSibling.innerHTML = "";
    document.getElementById("ceiling-height").nextElementSibling.innerHTML = "";
    document.getElementById("ceiling-length").value = "";
    document.getElementById("ceiling-width").value = "";
    document.getElementById("ceiling-height").value = "";
    document.getElementById("ceiling-result").innerHTML = "";
    document.getElementById("ceiling-result8").innerHTML = "";
    document.getElementById("ceiling-result10").innerHTML = "";
    document.getElementById("ceiling-result12").innerHTML = "";
    document.getElementById("result-container").classList.add("hidden");
  }
});

  } catch(e) { console.error(e); }
})();
})();
